import { css as _css } from "@emotion/core";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';
import { FilterType } from '@domain-group/fe-allhomes-search-api';
import AllhomesSearchPropertyType from '@domain-group/fe-co-allhomes-search-property-type';
import AllhomesSearchPriceRange from '@domain-group/fe-co-allhomes-search-price-range';
import Dropdown from '@domain-group/fe-co-allhomes-dropdown';
import AllhomesSearchPropertyFeatures from '@domain-group/fe-co-allhomes-search-property-features';
import { withMedia } from 'react-media-query-hoc';
import ScrollableDropdown from './components/scrollable-dropdown/scrollable-dropdown';
import MoreOptions from './components/more-options';
import filterStateHandler from './wrappers/filter-state-handler';
import CommonPropTypes, { defaultProps } from './prop-types/common';
import * as styles from './allhomes-search-filter.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesSearchFilter extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onButtonClick", () => {
      Promise.resolve(this.props.onSubmitFilter()).then(() => {
        this.closeDropdowns();
      });
    });
    _defineProperty(this, "closeDropdowns", () => {
      this.dropdowns.forEach(dropdown => dropdown.ensureClosed(false));
    });
    _defineProperty(this, "registerDropdown", refObj => {
      this.dropdowns.add(refObj);
    });
    _defineProperty(this, "isCommercial", () => ListingType[this.props.listingType] && ListingType[this.props.listingType].isCommercial);
    _defineProperty(this, "hasAnyFilter", filterTypes => filterTypes.some(filterType => this.props.filters.available().includes(filterType.name)));
    this.dropdowns = new Set();
  }
  render() {
    return ___EmotionJSX("div", {
      className: this.props.className,
      css: styles.container
    }, ___EmotionJSX("div", {
      css: styles.dropdowns
    }, this.hasAnyFilter([FilterType.propertyTypes]) && ___EmotionJSX(Dropdown, {
      css: styles.dropdown,
      anchorClass: "property-type",
      title: this.props.propertyTypeProps.staticTitle,
      onClose: this.props.onCancel,
      ref: this.registerDropdown
    }, ___EmotionJSX("div", {
      css: /*#__PURE__*/_css([styles.dropdownPaddedContainer, styles.propertyType])
    }, ___EmotionJSX(AllhomesSearchPropertyType, _extends({}, this.props.propertyTypeProps, {
      onButtonClick: this.onButtonClick
    })))), ___EmotionJSX(Dropdown, {
      css: styles.dropdown,
      anchorClass: "price-range",
      title: this.props.priceRangeProps.staticTitle,
      onClose: this.props.onCancel,
      ref: this.registerDropdown
    }, ___EmotionJSX("div", {
      css: styles.dropdownPaddedContainer
    }, ___EmotionJSX(AllhomesSearchPriceRange, _extends({}, this.props.priceRangeProps, {
      onButtonClick: this.onButtonClick
    })))), this.hasAnyFilter([FilterType.beds, FilterType.baths, FilterType.parking]) && ___EmotionJSX(Dropdown, {
      css: styles.dropdown,
      anchorClass: "property-features",
      title: this.props.propertyFeaturesProps.staticTitle,
      onClose: this.props.onCancel,
      ref: this.registerDropdown,
      align: this.props.media.tablet ? 'centre' : 'left'
    }, ___EmotionJSX("div", {
      css: styles.dropdownPaddedContainer
    }, ___EmotionJSX(AllhomesSearchPropertyFeatures, _extends({}, this.props.propertyFeaturesProps, {
      onButtonClick: this.onButtonClick
    })))), ___EmotionJSX(Dropdown, {
      css: styles.dropdown,
      anchorClass: "more-options",
      title: this.props.moreOptionsProps.staticTitle,
      onClose: this.props.onCancel,
      ref: this.registerDropdown,
      align: this.props.media.tablet && !this.isCommercial() ? 'right' : 'centre'
    }, ___EmotionJSX(ScrollableDropdown, {
      heightOffset: this.props.dropdownHeightOffset,
      onApplyClick: this.onButtonClick,
      onResetButtonClick: this.props.onClearMoreOptions,
      showResetButton: true
    }, ___EmotionJSX("div", {
      css: styles.moreOptionsPaddedContainer
    }, ___EmotionJSX(MoreOptions, this.props.moreOptionsProps)))), ___EmotionJSX("button", {
      type: "button",
      css: styles.resetButton,
      onClick: this.props.onClearAll,
      disabled: !this.props.hasFilterChanged()
    }, "Reset")), ___EmotionJSX("div", {
      css: styles.spacer
    }));
  }
}
AllhomesSearchFilter.propTypes = _objectSpread(_objectSpread({}, CommonPropTypes), {}, {
  dropdownHeightOffset: PropTypes.number,
  onClearMoreOptions: PropTypes.func,
  className: PropTypes.string
});
AllhomesSearchFilter.defaultProps = _objectSpread(_objectSpread({}, defaultProps), {}, {
  onDropdownClose: () => {},
  onClearMoreOptions: () => {},
  dropdownHeightOffset: 120,
  className: ''
});
export default filterStateHandler(withMedia(AllhomesSearchFilter), {
  isMobile: false
});